import api from "./api";

export default {
	getApproximateLocation: async () => api.get("/geolocation/approximate"),
};
